import React from 'react';
import styled, { css } from 'styled-components';
import { Text } from 'rebass';

export const ellipsisMixin = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const isString = s => typeof s === 'string';
const getText = nodes => isString(nodes) ? nodes : React.Children.toArray(nodes).map(n => isString(n) ? n : getText(n.props.children)).join('');

export default styled(({ children, title, ...props }) => <Text title={title || getText(children)} {...props}>{children}</Text>)`
  ${ellipsisMixin}
`;



// WEBPACK FOOTER //
// ./src/components/Atoms/Ellipsis/index.js